import { Button, Form, FormProps, Input } from 'antd';
import React from 'react';
import { getPaidAmountForm } from './actions';
import { filterDigits, localize } from '/react4xp/mixins/helpers';

type Props = {
    translations: Record<string, string>;
    onSuccess: (data: { paidAmountXML: string; taxpayerCode: string }) => void;
};

type Inputs = {
    taxpayerCode: string;
};

export function PaidAmountFirstStepForm(props: Props) {
    const [form] = Form.useForm();

    const onFinish: FormProps<Inputs>['onFinish'] = async (values) => {
        const paidAmountXML = await getPaidAmountForm(values);
        props.onSuccess({
            paidAmountXML,
            taxpayerCode: values.taxpayerCode,
        });
    };

    return (
        <Form
            layout={'vertical'}
            name={'paid-amounts-service-step-1'}
            onFinish={onFinish}
        >
            <Form.Item
                name={'taxpayerCode'}
                label={'ИИН'}
                rules={[
                    {
                        required: true,
                        message: localize('error.field-is-required', props.translations),
                    },
                    {
                        min: 12,
                        message: 'Поле ИИН должно состоять из 12 цифр',
                    },
                ]}
            >
                <Input
                    onChange={filterDigits(form, 'taxpayerCode')}
                    maxLength={12}
                    placeholder={localize('placeholder.input', props.translations)}
                />
            </Form.Item>

            <Button htmlType={'submit'}>{localize('button.send', props.translations)}</Button>
        </Form>
    );
}
